export const products = [
    {
        heading: 'Model S',
        subHeading: 'Order Online for Touchless Delivery',
        imageURL: 'https://tesla-cdn.thron.com/delivery/public/image/tesla/676da95d-942e-414c-8534-f1832f0d4ced/bvlatuR/std/3296x1798/ms-homepage-desktop',
        downArrow: true
    },
    {
        heading: 'Model Y',
        subHeading: 'Order Online for Touchless Delivery',
        imageURL: 'https://tesla-cdn.thron.com/delivery/public/image/tesla/8e2df1b9-a4bf-4eb9-beec-2cf5cc77fca0/bvlatuR/std/2880x2400/Desktop-ModelY?quality=70',
    },
    {
        heading: 'Model 3',
        subHeading: 'Order Online for Touchless Delivery',
        imageURL: 'https://tesla-cdn.thron.com/delivery/public/image/tesla/e90a341e-f9ca-4aa1-8eab-94afea118786/bvlatuR/std/2880x1800/M3-Homepage-D',
    },
    {
        heading: 'Model X',
        subHeading: 'Order Online for Touchless Delivery',
        imageURL: 'https://tesla-cdn.thron.com/delivery/public/image/tesla/325743a2-d187-4e28-91a3-5a2e47e317f7/bvlatuR/std/2880x1800/ModelX-Homepage-D',
    },
    {
        heading: 'Solar Panels',
        subHeading: 'Lowest Cost Solar Panels in America',
        imageURL: 'https://tesla-cdn.thron.com/delivery/public/image/tesla/16b04537-a4be-4bf9-8637-86862a858da8/bvlatuR/std/2880x1800/_25-HP-SolarPanels-D',
    },
    {
        heading: 'Solar Roof',
        subHeading: 'Produce Clean Energy From Your Roof',
        imageURL: 'https://tesla-cdn.thron.com/delivery/public/image/tesla/c877126e-0db5-409d-a412-04fc94b59b76/bvlatuR/std/2880x1800/HP-SR-Design-D',
    },
    {
        heading: 'Accessories',
        subHeading: '',
        imageURL: '//tesla-cdn.thron.com/delivery/public/image/tesla/dd739764-bcaa-4263-9488-8c73bc9fb046/bvlatuR/std/2880x2400/Desktop-Accessories',
    },
]